let $ = jQuery;

import Swiper from 'swiper/bundle';

import isMobile from './helpers/mobile'
var scrollStatus = false;

let swiper;
let timeout;

const build = () => {

    if (isMobile()) {
        $('.what-we-do .swiper-wrapper').on('scroll', function(e) {
            var percent = this.scrollLeft / totalWidth * 100;
            var pixels = $(window).width() * percent / 100;
            pixels = pixels + 30;
            $('.what-we-do .drag').width(pixels);
        })

        var totalWidth = $(window).width() * -1;
        totalWidth = totalWidth + 30;
        $('.what-we-do .swiper-wrapper .swiper-slide').each(function() {
            totalWidth += $(this).width();
        });
    } else {
        //Desktop

        addMouseListeners();
        checkMotion();
        $(window).scroll(function() {
            checkMotion();

        });
    }

}
const scrollDiv = e => { /*console.log(e)*/ }

const addMouseListeners = e => {
    // $('svg g.g2 g.icon').on('mouseenter', function() {
    //     var enter = $(this).attr('class').replace('icon ', 'g.hover.');
    //     $(enter).css('opacity', 1);
    // })
    // $('svg g.g2 g.icon').on('mouseleave', function() {
    //     var enter = $(this).attr('class').replace('icon ', 'g.hover.');
    //     $(enter).css('opacity', 0);
    // })

    $('svg g.g1 g.arrow').on('mouseenter', function() {
        var enter = $(this).attr('class').replace('arrow ', '.text.');

        $(enter).css('opacity', 1);
    })
    $('svg g.g1 g.arrow').on('mouseleave', function() {
        var enter = $(this).attr('class').replace('arrow ', '.text.');
        $(enter).css('opacity', 0);
    })
}

const checkMotion = e => {
    var wH = window.innerHeight / 2;
    var oTop = $('section.what-we-do').offset().top - wH;
    var oBottom = oTop + $('section.what-we-do').height() + wH;

    if ($(window).scrollTop() > oTop && $(window).scrollTop() < oBottom) {

        if (!scrollStatus) {
            scrollStatus = true;
            motionInTheory();
        }

    } else {
        if (scrollStatus) {
            scrollStatus = false;
            motionOutTheory();
        }
    }
}

const motionInTheory = e => {
    var i = 1;
    // $('svg g.g2 g.hover').each(function() {
    //     var _this = this;
    //     setTimeout(function(_this) {
    //         $(_this).css('opacity', 0);
    //     }, 1000 + 50 * i, _this)
    //     i++;
    // });
    $('svg g.g1 g.text').each(function() {
        var _this = this;
        setTimeout(function(_this) {
            $(_this).css('opacity', 0);
        }, 500 + 100 * i, _this)
        i++;
    });


    //console.log('motion in');
    //$('svg g.g2 g.hover').css('opacity', 0);
}
const motionOutTheory = e => {
    $('svg g.g1 .text , svg g.g1 .arrow').css('opacity', 1);
    $('svg g.g2 g.hover').css('opacity', 1);

}
const onResize = e => {
    clearTimeout(timeout)
    timeout = setTimeout(() => build(), 500)
}

export default () => {
    build()
    window.addEventListener('resize', onResize)
}